<template>
    <div :class="isShow ? 'left-navigation unfolds' : 'left-navigation packs'">
        <ul class="nav-ul">
            <!-- <li class="nav-li-item nav-li-item-1" @click="entRegister">
                <span class="item-icon icon-image"></span>
                <h6 class="item-label"><span>企业注册</span></h6>
            </li> -->
            <li class="nav-li-item nav-li-item-2">
                <router-link :to="{ path: '/helpCenter' }">
                    <span class="item-icon icon-image"></span>
                    <h6 class="item-label"><span>平台帮助</span></h6>
                </router-link>
            </li>
            <li class="nav-li-item nav-li-item-3">
                <span class="item-icon icon-image"></span>
                <h6 class="item-label">
                    <span>甘肃信易贷<br />陇信通</span>
                </h6>
            </li>
            <li class="nav-li-item nav-li-item-4">
                <span class="item-icon icon-image"></span>
                <h6 class="item-label"><span>电话咨询</span></h6>
                <div class="phone-box">
                    <p>0931-8101279</p>
                    <p>服务热线</p>
                </div>
            </li>
            <li class="nav-li-item nav-li-item-5" @mousemove="xcxCodeShow = true" @mouseleave="xcxCodeShow = false">
                <span class="item-icon icon-image"></span>
                <h6 class="item-label"><span>企业微信</span></h6>
                <div class="quick-mark" v-if="xcxCodeShow">
                    <img :src="xcxCodeImg" alt="小程序" />
                </div>
            </li>
            <li class="nav-li-item nav-li-item-6" @click="messageBoardFun">
                <!-- <router-link :to="{ path: '/messageBoard' }"> -->
                    <span class="item-icon icon-image"></span>
                    <h6 class="item-label"><span>留言板</span></h6>
                <!-- </router-link> -->
            </li>

            <li class="nav-li-item nav-li-item-7" @mousemove="wjCodeShow = true" @mouseleave="wjCodeShow = false">
                <span class="item-icon icon-image"></span>
                <h6 class="item-label"><span>问卷调查</span></h6>
                <div class="quick-wjmark" v-if="wjCodeShow">
                    <span>小微企业问卷调查</span><img :src="wjCodeImg1" alt="小微企业问卷调查" />
                    <span>金融机构问卷调查</span><img :src="wjCodeImg2" alt="金融机构问卷调查" />
                </div>
            </li>

            <!-- <li class="nav-li-item nav-li-item-5">
                <span class="item-icon icon-image"></span>
                <h6 class="item-label"><span>异议申诉</span></h6>
            </li> -->
        </ul>
        <div class="Navigation" @click="isShow = !isShow">>> 快捷导航</div>
    </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { isParamEmpty } from "@/filters";
// import
export default {
    data() {
        return {
            isShow: true,
            xcxCodeShow: false,
            wjCodeShow: false,
            xcxCodeImg: require("@/assets/xyd/index/xcxCode.png"),
            wjCodeImg1: require("@/assets/xyd/index/wjCode1.png"),
            wjCodeImg2: require("@/assets/xyd/index/wjCode2.png"),
        };
    },
    methods: {
        entRegister() {
            this.$parent.$parent.registerAccount("YHZC");
        },
        messageBoardFun() {
            console.log(getToken())
            if(getToken()) {
                this.$router.push('/messageBoard')
            }else {
                this.$store.commit("user/setLoginDialogStatus", true);
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.left-navigation {
    position: absolute;
    width: 100px;
    // height: 462px;
    z-index: 999;
    top: 40%;
    // left: -100px;
    border-radius: 8px;
    margin-top: -203px;
    padding: 20px 0;
    // border: 1px solid #0090FF;
    background-color: #fff;
    box-shadow: 0px 2px 5px #ccc;

    .Navigation {
        position: absolute;
        right: -40px;
        top: 50%;
        width: 30px;
        text-align: center;
        background: #0e73db;
        color: #ffffff;
        font-size: 16px;
        padding: 10px 5px;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
        margin-top: -50px;
        cursor: pointer;
    }
    .nav-li-item {
        position: relative;

        // height: 80px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10px 0;

        & > a {
            text-align: center;
        }

        .item-icon {
            display: inline-block;
            width: 30px;
            height: 30px;
            margin-bottom: 8px;
        }

        .item-label > span {
        }

        h6 {
            font-size: 14px;
            text-align: center;
            color: #848587;
            line-height: 20px;
        }

        &.nav-li-item-3 {
            .item-icon {
                display: inline-block;
                width: 60px;
                height: 60px;
                margin-bottom: 8px;
            }
        }
       /* &.nav-li-item-7 {
            .item-icon {
                display: inline-block;
                width: 60px;
                height: 60px;
                margin-bottom: 8px;
            }
        }*/

        &.nav-li-item-1 .item-icon {
            background: url("./../assets/xyd/index/icon-11.png") no-repeat
                center center;
            background-size: 30px 30px;
        }

        &.nav-li-item-2 .item-icon {
            background: url("./../assets/xyd/index/icon-12.png") no-repeat
                center center;
            background-size: 30px 30px;
        }

        &.nav-li-item-3 .item-icon {
            background: url("./../assets/xyd/index/qr-code.png") no-repeat
                center center;
            background-size: 60px 60px;
        }
        &.nav-li-item-7 .item-icon {
            background: url("./../assets/xyd/index/icon-49-1.png")
            center center;
            background-size: 30px 30px;
        }

        &.nav-li-item-4 {
            &:hover {
                .phone-box {
                    display: block;
                }
            }

            .item-icon {
                background: url("./../assets/xyd/index/icon-48.png") no-repeat
                    center center;
                background-size: 25px 25px;
            }
            .phone-box {
                position: absolute;
                top: 0px;
                left: 100px;
                // width: 180px;
                z-index: 999;
                background: #fff;
                padding: 10px 20px;
                text-align: center;
                font-size: 18px;
                line-height: 28px;
                border: 1px solid #0e73db;
                border-radius: 5px;
                display: none;
                p{
                  white-space: nowrap;
                }
            }
        }

        &.nav-li-item-5 .item-icon {
            background: url("./../assets/xyd/index/icon-52.png") no-repeat
                center center;
            background-size: 30px 30px;
        }

        &.nav-li-item-6 .item-icon {
            background: url("./../assets/xyd/index/icon-49-1.png")
            center center;
            background-size: 30px 30px;
        }
    }

    .telephone-num {
        position: absolute;
        top: 0;
        left: 70px;
        width: 180px;
        background: #fff;
        border: 1px solid #0090ff;
        padding: 10px;
        border-radius: 5px;
        text-align: center;
        cursor: default;

        .num {
            font-size: 24px;
            color: #0090ff;
            line-height: 34px;
        }

        .text {
            font-size: 14px;
            color: #818181;
        }
    }

    .quick-mark {
        position: absolute;
        top: 0;
        left: 100px;
        padding: 10px;
        border-radius: 5px;
        border: 1px solid #0090ff;
        background-color: #fff;

        img {
            width: 137px;
        }
    }

    .quick-wjmark {
        display: flex;
        position: absolute;
        top: 0;
        left: 100px;
        padding: 10px;
        border-radius: 5px;
        border: 1px solid #0090ff;
        background-color: #fff;

        img {
            width: 137px;
        }
    }
}
.unfolds {
    left: 0px;
    animation: unfold 0.5s;
}
.packs {
    left: -100px;
    animation: pack 0.5s;
}
// 动画
@keyframes unfold {
    0% {
        left: -100px;
    }
    100% {
        left: 0;
    }
}
@keyframes pack {
    0% {
        left: 0;
    }
    100% {
        left: -100px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/RightLogin.vue